// @flow
import 'react-quill/dist/quill.snow.css'
import './editor.css'

import { useFormikContext } from 'formik'
import * as React from 'react'

import { TextEditor } from '@/components/TextEditor'
import { parseHTMLToPlainText } from '@/utils/parseHTMLToPlainText'

type Props = {
  field: { name: string },
  maxLength?: number,
  multiline?: boolean,
  placeholder: string,
}

function SettingsTextInputWithVariables({
  field,
  maxLength,
  multiline,
  placeholder,
}: Props): React.Node {
  const { setFieldValue } = useFormikContext()

  const onChange = React.useCallback(
    (value) => {
      setFieldValue(field.name, parseHTMLToPlainText(value))
    },
    [field.name, setFieldValue]
  )

  return (
    <div>
      <TextEditor
        className="text-sm"
        minHeight={30}
        tools={['variables']}
        value={parseHTMLToPlainText(field.value)}
        {...{
          maxLength,
          placeholder,
          onChange,
        }}
      />
    </div>
  )
}

export default SettingsTextInputWithVariables
